module.exports = __webpack_public_path__ + "static/transforming-the-future-6af577103fa0ee1553645c39104d0785.jpg";